import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '60px',
    marginBottom: '32px'
  },
  header1: {
    height: '60px',
    marginBottom: '10px'
  },
  filters: {
    height: '32px',
    marginBottom: '10px',
    marginRight: '5px'
  },
  center: {
    height: '41px',
    marginBottom: '32px'
  },
  box: {
    height: '518px'
  }
};

const SkeletonHotelLowRateCalendarMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, header1, filters, center, box } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="SkeletonHotelLowRateCalendarMobile"
    >
      <Row gutters>
        <Col xs="12">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
        <Col xs="12">
          <Box className="fr-skeleton-element" style={header1} />
        </Col>
      </Row>
      <Row gutters={false}>
        <Col xs="5">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
        <Col xs="5">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={center} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={box} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonHotelLowRateCalendarMobile.componentName = 'SkeletonHotelLowRateCalendarMobile';

export default SkeletonHotelLowRateCalendarMobile;
